import {
  CreditCardError,
  CreditCardErrors
} from '../components/ApplicationProgress/CreditCardSubmitted/types'
import { Address } from './address'

export type CreditAcceptResponse = {
  id: string
  status: CardStatus
}

export type CreditCardStatusResponse = CreditAcceptResponse & {
  replacedId: string
}

export type CreditCardDetails = CreditCardStatusResponse & {
  address: Address
}

export enum CardStatus {
  waiting = 'waiting',
  ready = 'ready',
  closed = 'closed',
  expired = 'expired',
  replacing = 'replacing',
  errored = 'errored',
  rejected = 'rejected'
}

export const REJECTED: CreditCardError = {
  type: CreditCardErrors.REJECTED,
  errorMessage: 'Card rejected'
}

export const GENERIC: CreditCardError = {
  type: CreditCardErrors.GENERIC,
  errorMessage: 'An error occured'
}
